import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactS3Uploader from "react-s3-uploader";

// Locals
import CouImageUploaderStatus from "./CouImageUploaderStatus";

// ------------------------------
// CouImageUploader
// ------------------------------
class CouImageUploader extends Component {
  state = {
    dimensions: null,
    uploading: false,
    uploadMessage: "",
    uploadPercentage: 0
  };

  onUploadStart = (file, next) => {
    const { name, size } = file;
    this.setState({ uploading: file.name });

    const img = new Image();

    img.src = window.URL.createObjectURL(file);

    img.onload = () => {
      this.setState({
        dimensions: {
          height: img.naturalHeight,
          name,
          size,
          width: img.naturalWidth
        }
      });
    };

    next(file);
  };

  onUploadProgress = (percent, message) => {
    this.setState({ uploadPercentage: percent, uploadMessage: message });
  };

  onUploadError = message => {
    this.setState({ uploadMessage: message });
  };

  onUploadFinish = (info, fileInfo) => {
    const { dimensions } = this.state;
    this.props.handleFinish(info.url, dimensions);
    this.node.clear();
    this.setState({ uploading: false, dimensions: null });
  };

  render() {
    const { accept, host, multiple } = this.props;
    const { uploading, uploadMessage, uploadPercentage } = this.state;

    return (
      <div className="CouImageUploader">
        {uploading && (
          <CouImageUploaderStatus
            uploading={uploading}
            uploadMessage={uploadMessage}
            uploadPercentage={uploadPercentage}
          />
        )}

        <ReactS3Uploader
          ref={node => (this.node = node)}
          signingUrl="/s3/sign"
          signingUrlMethod="GET"
          accept={accept}
          preprocess={this.onUploadStart}
          onProgress={this.onUploadProgress}
          onError={this.onUploadError}
          onFinish={this.onUploadFinish}
          uploadRequestHeaders={{ "x-amz-acl": "public-read" }} // this is the default
          contentDisposition="inline"
          server={host}
          autoUpload={true}
          multiple={multiple}
        />
      </div>
    );
  }
}

CouImageUploader.defaultProps = {
  accept: "image/*",
  host: location.protocol + "//" + location.host
};

CouImageUploader.propTypes = {
  accept: PropTypes.string,
  host: PropTypes.string
};

export default CouImageUploader;
